<script lang="ts">
  import MainLayout from "../#common/layout/Layout.svelte"
  import { Table } from 'sveltestrap'
  import Pagination from 'src/components/#common/pagination/Pagination.svelte'
  import {multiAccounts} from 'src/components/cabinet/#services/user'
  import PerPage from 'src/components/#common/pagination/PerPage.svelte'

  let userIds = ''
  let currentPage = 0
  let perPage = 25
  let type = 'ipAddress'

  function filter() {
    multiAccounts.reset()
    multiAccounts.send({ data: {
        userIds,
        page:currentPage + 1,
        perPage,
        type,
    }})
    $multiAccounts.value
  }

  $:userIds,type,perPage,currentPage,filter()
</script>

<svelte:head>
  <title>Multi Accounts</title>
</svelte:head>

<MainLayout title="Top Holders">
  <svelte:fragment slot="content">
      <div class="card">
          <div class="card-body">
              <div class="buttons">
                  <div class="pc-line">
                      <span class="date-label">User IDs</span>
                      <input type="text" class="form-control" placeholder="Separated by comma" bind:value={userIds}>
                  </div>
                  <div class="pc-line">
                      <span class="date-label">Detected by</span>
                      <select class="form-select" bind:value={type}>
                          <option value="ipAddress">Ip Address</option>
                          <option value="recipientAddress">Recipient Address</option>
                          <option value="productId">Product Id</option>
                      </select>
                  </div>
              </div>
              <div class="transactions-list">
                  <Table bordered striped responsive>
                      <thead>
                      <tr>
                          <td class="text-center user-ids-col">Accounts</td>
                          <td class="text-center">Total Balances</td>
                          {#if type === 'ipAddress'}
                          <td class="text-center">Ip Address</td>
                          {:else if type === 'recipientAddress'}
                          <td class="text-center">Recipient Address</td>
                          {:else if type === 'productId'}
                          <td class="text-center">Product Id</td>
                          {/if}
                      </tr>
                      </thead>
                      <tbody>
                      {#if $multiAccounts.loading}
                        <tr>
                          <td><span class="loading transaction-loading"></span></td>
                          <td><span class="loading transaction-loading"></span></td>
                          <td><span class="loading transaction-loading"></span></td>
                        </tr>
                      {:else if $multiAccounts.error || !$multiAccounts.hasValue}
                          <tr>
                              <td class="text-center" colspan="3">
                                  {#if $multiAccounts.error}
                                      {$multiAccounts.error}
                                  {:else}
                                      Something went wrong. Try refreshing the page.
                                  {/if}
                              </td>
                          </tr>
                      {:else}
                          {#each $multiAccounts.value.data as {userIds, totalBalances, ipAddress, recipientAddress, productId}, i}
                              <tr>
                                  <td class="text-left user-ids-col">
                                    {#if userIds === ''}
                                      Unable to display becase of high quantity of accounts.
                                    {:else}
                                      {#each userIds.toString().split(',') as userId, idx}
                                        <a href="profile/{userId}" target="_blank" rel="noreferrer">{userId}</a>{#if userIds.toString().split(',').length - 1 !== idx}, {/if}
                                      {/each}
                                    {/if}
                                  </td>
                                  <td class="text-left">
                                    {#if totalBalances}
                                      {#each Object.keys(totalBalances) as key}
                                        {key}: {totalBalances[key]} <br>
                                      {/each}
                                    {:else}
                                    —
                                    {/if}
                                  </td>
                                  {#if type === 'ipAddress'}
                                  <td class="text-center">{ ipAddress }</td>
                                  {:else if type === 'recipientAddress'}
                                  <td class="text-center">{ recipientAddress }</td>
                                  {:else if type === 'productId'}
                                  <td class="text-center">{ productId }</td>
                                  {/if}
                              </tr>
                          {:else}
                              <tr>
                                  <td class="text-center" colspan="5">No items</td>
                              </tr>
                          {/each}
                      {/if}
                      </tbody>
                  </Table>
                  {#if $multiAccounts.hasValue}
                    <Pagination
                        bind:currentPage={currentPage}
                        totalCount={$multiAccounts.value.totalCount}
                        {perPage}
                        disabled={$multiAccounts.loading || $multiAccounts.loading}
                    />
                  {/if}
              </div>
          </div>
      </div>
  </svelte:fragment>
</MainLayout>

<style>
  .buttons {
    margin-bottom: 15px;
  }

  .user-ids-col {
    max-width: 600px;
  }

  .text-right {
      text-align: right;
  }

  .transaction-loading {
      height: 24px;
      width: 100%;
      display: block;
  }

  .pc-line {
      display: inline-block;
      vertical-align: top;
  }

  .transaction-loading {
      height: 24px;
      width: 100%;
      display: block;
  }

  .date-label {
    padding: 0 5px;
    line-height: 38px;
  }

  .form-select, .form-control {
    width: auto;
    display: inline-block;
    vertical-align: top;
    width: 300px;
  }

  input[type="date"] {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  @media(max-width: 767px) {
      .pc-line {
          display: block;
      }
  }
</style>
